import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Login from "./pages/login";

import AdminRoutes from "./pages/admin/adminroutes";
import UserRoutes from "./pages/user/userroutes";

import MainLayout from "./Mainlayout";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route element={<MainLayout />}>
          <Route path="/admin/*" element={<AdminRoutes />} />
          <Route path="/dashboard/*" element={<UserRoutes />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
